import { getLocaleRegionIdFromPath } from '@sans-souci/utils'
import { groq } from 'next-sanity'
import { getClient } from './getClient'
import { PageBuilderSection, PageResponse } from '@sans-souci/models'
import { createProductPageProjection } from './projections/createProductPageProjection'

export const getProductPage = async (
  handle: string,
  localeRegion: string,
  preview = false,
): Promise<Omit<NonNullable<PageResponse<PageBuilderSection[]>>, 'seo'>> => {
  const [regionId, localeId] = getLocaleRegionIdFromPath(localeRegion)

  const PRODUCT_PAGE_PROJECTION = createProductPageProjection(
    regionId,
    localeId,
  )

  const query = (() => {
    if (preview) {
      return groq`*[_type == "product" && defined(store.slug.current) && store.slug.current == $handle][0]${PRODUCT_PAGE_PROJECTION}`
    }

    return groq`*[!(_id in path('drafts.**')) && _type == "product" && defined(store.slug.current) && store.slug.current == $handle && store.isDeleted == false && store.status == "active"][0]${PRODUCT_PAGE_PROJECTION}`
  })()

  return await getClient(preview).fetch(query, {
    handle,
  })
}
